import { Component, Input } from '@angular/core';
import { SharedConstants, SharedCSSPropertyName } from '@app/eds';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent {
  // name provides avatar text.
  @Input() name: string = SharedConstants.EMPTY_STRING;

  // avatar styles like width, height and background-color.
  @Input() avatarWidth!: string;
  @Input() avatarHeight!: string;
  @Input() bgColor!: string;

  // avatarImg provides image url.
  @Input() avatarImg: string = SharedConstants.EMPTY_STRING;

  /**
   * This method will help to return styles for avatar.
   *
   * @returns {object} an object of custom styles
   */
  getStyles = () => {
    // provides first letter in capital
    this.name = this.name.charAt(0).toUpperCase();
    const stylingObj: { [key: string]: string } = {};

    this.avatarHeight && (stylingObj[SharedCSSPropertyName.HEIGHT] = this.avatarHeight);
    this.avatarWidth && (stylingObj[SharedCSSPropertyName.WIDTH] = this.avatarWidth);
    this.bgColor != null &&
      (stylingObj[SharedCSSPropertyName.BACKGROUND_COLOR] = this.bgColor);
    this.avatarImg &&
      (stylingObj[SharedCSSPropertyName.BACKGROUND_IMAGE] = `url(${this.avatarImg})`);

    return stylingObj;
  };
}
